import React from "react";

import Section1 from "../includes/MeetTheTeam/Section1";
import Section2 from "../includes/MeetTheTeam/Section2";
import Section3 from "../includes/MeetTheTeam/Section3";
import Section4 from "../includes/MeetTheTeam/Section4";

// form from homepage

import Section9 from "../includes/Home/Section9";

// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";

const MeetTheTeam = ({ devUrl }) => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "exddigital.com",
    },
    headline: "ExD Digital - Meet the Team",
    image: "https://www.exddigital.com/images/our-team/main-banner.jpg",
    author: {
      "@type": "Organization",
      name: "ExD Digital - Meet the Team",
      url: "https://www.exddigital.com/meet-the-team",
    },
    publisher: {
      "@type": "Organization",
      name: "ExD Digital",
      logo: {
        "@type": "ImageObject",
        url: "https://www.exddigital.com/images/exd_digital.png",
      },
    },
    datePublished: "2023-08-05",
    dateModified: "2023-08-06",
  };
  return (
    <>
      <Helmet>
        <title>Meet the Team</title>
        <link rel="canonical" href="https://www.exddigital.com/meet-the-team" />
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <main className="meet-the-team-main">
        <article className="team">
          <Section1 url={devUrl} />
          <Section3 url={devUrl} />
          <Section4 url={devUrl} />
          {/* <Section2 url={devUrl} /> */}
          <Section9 url={devUrl} />
        </article>
      </main>
    </>
  );
};
export default React.memo(MeetTheTeam);
